module.exports = __webpack_public_path__ + "media/meditate.97dce1b4.mp3";